import { Check, ChevronDown } from 'react-feather';
import styles from '../rentalappplication.module.css';
import { Accordion, AccordionDetails, AccordionSummary, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import dayjs from 'dayjs';
import NumberFormat from 'react-number-format';
import axios from 'axios';
import { usePlacesWidget } from 'react-google-autocomplete';

const TenDigitField = React.forwardRef((props, ref) => {
    return <NumberFormat
        customInput={TextField}
        prefix=""
        displayType="input"
        type="text"
        thousandSeparator={false}
        decimalScale={0}
        {...props}
    />;
});

const MoneyField = React.forwardRef((props, ref) => {
    return <NumberFormat
        customInput={TextField}
        prefix=""
        displayType="input"
        type="text"
        thousandSeparator={true}
        allowNegative={false}
        decimalScale={0}
        {...props}
    />;
});

const Employment2Accordion = ({ expanded, stepData, setStepData, accordinChange, lastStep, setLastStep, setCurrentStep, getNextStep, setPanelExpanded, panelRef, applicantId }) => {
    const [incomeType, setIncomeType] = useState('Salary');
    const { handleSubmit, control, setValue, formState: { errors }, clearErrors } = useForm({
        mode: "onChange",
        defaultValues: {
            employement2: '',
            employer_name2: '',
            employer_address2: '',
            years_employed2: '',
            job_title2: '',
            income_type2: 'Salary',
            income_per_year2: '',
            voucher_amount2: '',
            hire_date2: null,
        }
    });

    useEffect(() => {
        if (stepData) {
            if (stepData?.employement2) {
                setValue('employement2', stepData?.employement2);
            }
            if (stepData?.employer_name2) {
                setValue('employer_name2', stepData?.employer_name2);
            }
            if (stepData?.employer_address2) {
                setValue('employer_address2', stepData?.employer_address2);
            }
            if (stepData?.years_employed2) {
                setValue('years_employed2', stepData?.years_employed2);
            }
            if (stepData?.job_title2) {
                setValue('job_title2', stepData?.job_title2);
            }
            if (stepData?.income_per_year2) {
                setValue('income_per_year2', stepData?.income_per_year2);
            }
            if (stepData?.hire_date2) {
                setValue('hire_date2', dayjs(stepData?.hire_date2));
            }
            if (stepData?.income_type2) {
                setIncomeType(stepData?.income_type2);
                setValue('income_type2', stepData?.income_type2);

                if (stepData?.income_type2 === 'Voucher' && stepData?.voucher_amount2) {
                    setValue('voucher_amount2', stepData?.voucher_amount2);
                }
            }
        }
    }, [stepData, setValue]);

    const { ref: autocompleteRef } = usePlacesWidget({
        apiKey: process.env.REACT_APP_MAP_API_KEY,
        options: {
            types: ["address"],
            componentRestrictions: { country: "us" },
            fields: ["address_components", "geometry"],
        },
        onPlaceSelected: (place) => {
            let address = "";
            let city = "";
            let state = "";
            let postcode = "";
            for (let component of place.address_components) {
                let componentType = component.types[0];
                switch (componentType) {
                    case "street_number": {
                        address = component.long_name;
                        break;
                    }
                    case "route": {
                        address += ' ' + component.short_name;
                        break;
                    }
                    case "postal_code": {
                        postcode = component.long_name;
                        break;
                    }
                    case "locality": {
                        if (city === '')
                            city = component.long_name;
                        break;
                    }
                    case "sublocality_level_1": {
                        city = component.long_name;
                        break;
                    }
                    case "administrative_area_level_1": {
                        state = component.short_name;
                        break;
                    }
                    default:
                        break;
                }
            }
            let full_address = address + ', ' + city + ', ' + state + ' ' + postcode;

            setValue('employer_address2', full_address);
            clearErrors();
        }
    });

    const onSubmit = (data) => {
        data = { ...data, hire_date2: dayjs(data?.hire_date2).format('YYYY-MM-DD') };

        let postData = { ...data, is_employement2_submitted: 1 };
        setStepData(prev => {
            return { ...prev, ...postData };
        });

        if (applicantId) {
            axios.post(process.env.REACT_APP_APPLICANT_API_URL + 'v1/save-applicants/' + applicantId, postData);
        }

        let currentStepTemp = getNextStep(6);
        setCurrentStep(currentStepTemp);
        setPanelExpanded('panel' + currentStepTemp);
        if (lastStep < currentStepTemp) {
            setLastStep(currentStepTemp);
        }
    }

    return (<Accordion expanded={expanded === 'panel6'} onChange={accordinChange('panel6', 6)} disabled={lastStep < 6}>
        <AccordionSummary expandIcon={<ChevronDown />} aria-controls="panel1bh-content" id="panel1bh-header" ref={panelRef}>
            <div className={`${styles.FormAccoHead}`}>
                <p className={`${styles.FormAccoHeadTitle}`}>2nd Employment</p>
                <div className={((lastStep > 6) ? `${styles.AccoCheck} ${styles.Active}` : `${styles.AccoCheck}`)}><Check /></div>
            </div>
        </AccordionSummary>
        <AccordionDetails className={`${styles.CussAccoRow}`}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className={`${styles.AccoFormSec}`}>

                    <div className={`${styles.FormGroupHalf} FormGroup CusRental`}>
                        <label className={`${styles.FormLabel}`}>Employment<span>*</span></label>
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Select</InputLabel>
                            <Controller
                                name="employement2"
                                control={control}
                                rules={{
                                    required: 'This field is required.',
                                }}
                                render={(field) => (
                                    <Select
                                        {...field}
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        onChange={(e) => {
                                            field.onChange(e);
                                        }}
                                    >
                                        < MenuItem value={'Full-Time'}>{'Full-Time'}</MenuItem>
                                        < MenuItem value={'Part-Time'}>{'Part-Time'}</MenuItem>
                                    </Select>
                                )}
                            />
                            {errors.employement2 && <p className={`${styles.ErrorM}`}>{errors.employement2.message}</p>}
                        </FormControl>
                    </div>
                    <div className={`${styles.FormGroupHalf} FormGroup CusRental`}>
                        <label className={`${styles.FormLabel}`}>Employer name<span>*</span></label>
                        <FormControl fullWidth>
                            <Controller
                                name="employer_name2"
                                control={control}
                                rules={{
                                    required: "This field is required.",
                                    maxLength: {
                                        value: 50,
                                        message: "Employer name can not be more than 50 characters."
                                    }
                                }}
                                render={(field) => (
                                    <TextField
                                        {...field}
                                        label="Name"
                                        onChange={(e) => {
                                            field.onChange(e);
                                        }}
                                    />
                                )}
                            />
                            {errors.employer_name2 && <p className={`${styles.ErrorM}`}>{errors.employer_name2.message}</p>}
                        </FormControl>
                    </div>

                    <div className={`${styles.FormGroupHalf} FormGroup CusRental`}>
                        <label className={`${styles.FormLabel}`}>Employer address<span>*</span></label>
                        <FormControl fullWidth>
                            <Controller
                                name="employer_address2"
                                control={control}
                                rules={{
                                    required: 'This field is required.',
                                    maxLength: {
                                        value: 50,
                                        message: "Employer address can not be more than 50 characters."
                                    }
                                }}
                                render={(field) => (
                                    <TextField
                                        {...field}
                                        inputRef={autocompleteRef}
                                        autoComplete='off'
                                        placeholder=""
                                        label="Address"
                                    />
                                )}
                            />
                            {errors.employer_address2 && <p className={`${styles.ErrorM}`}>{errors.employer_address2.message}</p>}
                        </FormControl>
                    </div>
                    <div className={`${styles.FormGroupHalf} FormGroup CusRental`}>
                        <label className={`${styles.FormLabel}`}>Years employed<span>*</span></label>
                        <FormControl fullWidth>
                            <Controller
                                name="years_employed2"
                                control={control}
                                rules={{
                                    required: 'This field is required.',
                                    masLength: {
                                        value: 2,
                                        message: "Years employeed can not be more than 2 digits."
                                    },
                                }}
                                render={(field) => (
                                    <TenDigitField
                                        {...field}
                                        format="##"
                                        label="No. of years"
                                        onChange={(e) => {
                                            field.onChange(e);
                                        }}
                                    />
                                )}
                            />
                            {errors.years_employed2 && <p className={`${styles.ErrorM}`}>{errors.years_employed2.message}</p>}
                        </FormControl>
                    </div>

                    <div className={`${styles.FormGroupHalf} FormGroup CusRental`}>
                        <label className={`${styles.FormLabel}`}>Job title<span>*</span></label>
                        <FormControl fullWidth>
                            <Controller
                                name="job_title2"
                                control={control}
                                rules={{
                                    required: "This field is required.",
                                    maxLength: {
                                        value: 50,
                                        message: "Employer name can not be more than 50 characters."
                                    }
                                }}
                                render={(field) => (
                                    <TextField
                                        {...field}
                                        label="Job title"
                                        onChange={(e) => {
                                            field.onChange(e);
                                        }}
                                    />
                                )}
                            />
                            {errors.job_title2 && <p className={`${styles.ErrorM}`}>{errors.job_title2.message}</p>}
                        </FormControl>
                    </div>
                    <div className={`${styles.FormGroupHalf} FormGroup CusRental`}>
                        <label className={`${styles.FormLabel}`}>Income Type<span>*</span></label>
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Select</InputLabel>
                            <Controller
                                name="income_type2"
                                control={control}
                                rules={{
                                    required: 'This field is required.',
                                }}
                                render={(field) => (
                                    <Select
                                        {...field}
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        onChange={(e) => {
                                            field.onChange(e);
                                            setIncomeType(e.target.value)
                                        }}
                                    >
                                        < MenuItem value={'Salary'}>{'Salary'}</MenuItem>
                                        < MenuItem value={'Voucher'}>{'Voucher'}</MenuItem>
                                    </Select>
                                )}
                            />
                            {errors.income_type2 && <p className={`${styles.ErrorM}`}>{errors.income_type2.message}</p>}
                        </FormControl>
                    </div>
                    {incomeType === 'Voucher' ? <div className={`${styles.FormGroupHalf} FormGroup CusRental`}>
                        <label className={`${styles.FormLabel}`}>Amount<span>*</span></label>
                        <FormControl fullWidth>
                            <Controller
                                name="voucher_amount2"
                                control={control}
                                rules={{
                                    required: 'This field is required.',
                                }}
                                render={(field) => (
                                    <MoneyField
                                        {...field}
                                        label="Amount"
                                        onChange={(e) => {
                                            field.onChange(e);
                                        }}
                                    />
                                )}
                            />
                            {errors.voucher_amount2 && <p className={`${styles.ErrorM}`}>{errors.voucher_amount2.message}</p>}
                        </FormControl>
                    </div> : <div className={`${styles.FormGroupHalf} FormGroup CusRental`}>
                        <label className={`${styles.FormLabel}`}>Income per year in USD<span>*</span></label>
                        <FormControl fullWidth>
                            <Controller
                                name="income_per_year2"
                                control={control}
                                rules={{
                                    required: 'This field is required.',
                                    maxLength: {
                                        value: 7,
                                        message: "Income per year can not be more than 6 digits."
                                    },
                                }}
                                render={(field) => (
                                    <MoneyField
                                        {...field}
                                        label="Amount"
                                        onChange={(e) => {
                                            field.onChange(e);
                                        }}
                                    />
                                )}
                            />
                            {errors.income_per_year2 && <p className={`${styles.ErrorM}`}>{errors.income_per_year2.message}</p>}
                        </FormControl>
                    </div>}

                    <div className={`${styles.FormGroupHalf} FormGroup CusRental`}>
                        <label className={`${styles.FormLabel}`}>Hire date<span>*</span></label>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <Controller
                                name="hire_date2"
                                control={control}
                                rules={{ required: 'This field is required.' }}
                                render={(field) => (
                                    <DatePicker
                                        {...field}
                                        renderInput={(params) => (
                                            <TextField {...params} />
                                        )}
                                        onChange={(e) => {
                                            field.onChange(e);
                                        }}
                                    />
                                )}
                            />
                        </LocalizationProvider>
                        {errors.hire_date2 && <p className={`${styles.ErrorM}`}>{errors.hire_date2.message}</p>}
                    </div>

                    <div className={`${styles.AccoFormBUsec}`}>
                        <button type="submit" className={`${styles.applicantNextBU}`}>NEXT</button>
                    </div>

                </div>
            </form>
        </AccordionDetails>
    </Accordion >);
}

export default Employment2Accordion;